import { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import { textCap18, textCap16 } from "../fonts/typography";
import { WorkOverview } from "./WorkOverview";
import { MobileWorkOverview } from "./MobileWorkOverview";
import { useMediaQuery } from "../utils/useMediaQuery";

export function NavBar() {
  const isMobile = useMediaQuery("(max-width: 599px)");
  const currentTextStyle = isMobile ? textCap16 : textCap18;
  const [showWork, setShowWork] = useState(false);
  const navRef = useRef(null);

  useEffect(() => {
    const nav = navRef.current;
    if (!nav) return;

    const updateHeight = () => {
      document.documentElement.style.setProperty(
        "--navbar-height",
        `${nav.offsetHeight}px`
      );
    };

    updateHeight();
    const resizeObserver = new ResizeObserver(updateHeight);
    resizeObserver.observe(nav);
    return () => resizeObserver.disconnect();
  }, [isMobile]);

  const handleToggleWork = () => setShowWork((prev) => !prev);

  return (
    <>
      <nav
        ref={navRef}
        className={`${
          showWork ? "navbar-open" : ""
        } navbar grid-twelve-cols-lg grid-four-cols-sm`}
      >
        {!showWork && (
          <Link
            style={currentTextStyle}
            className="navbar-link start-one-lg span-two-lg start-one-sm span-one-sm"
            id="home"
            to="/"
            aria-label="G.R.©2025"
          >
            G.R.©
          </Link>
        )}

        <button
          style={{
            ...currentTextStyle,
            textDecoration: showWork ? "underline" : "",
            textUnderlineOffset: "2px",
            cursor: "pointer",
          }}
          className="navbar-link start-six-lg span-two-lg start-two-sm span-two-sm nav-btn"
          id="work"
          onClick={handleToggleWork}
        >
          Work
        </button>

        {showWork ? (
          <button
            style={{
              ...currentTextStyle,
              cursor: "pointer",
            }}
            className="navbar-link start-eleven-lg span-two-lg start-four-sm span-one-sm nav-btn"
            id="about"
            onClick={handleToggleWork}
          >
            Close
          </button>
        ) : (
          <Link
            style={currentTextStyle}
            className="navbar-link start-eleven-lg span-two-lg start-four-sm span-one-sm"
            id="about"
            to="/about"
          >
            About
          </Link>
        )}
      </nav>

      <div
        className={`overlay-content ${showWork ? "show" : ""}`}
        role="dialog"
        aria-modal="true"
        aria-hidden={!showWork}
        tabIndex={showWork ? 0 : -1}
      >
        {isMobile ? (
          <MobileWorkOverview
            onNavigate={() => setShowWork(false)}
            isVisible={showWork}
          />
        ) : (
          <WorkOverview
            onNavigate={() => setShowWork(false)}
            isVisible={showWork}
          />
        )}
      </div>
    </>
  );
}
